import { Vector3 } from "@babylonjs/core";
import { IArteffactData } from "../interfaces/IArteffactData";

export const arteffacts:{[key:string]: IArteffactData} = {
  "altar_table": {
    name: "Мраморна олтарна маса ( V – VI в.)",
    file: "Altar_Table.glb",
    hall: "Зала \"Ранно Християнство\"",
    logo: "am-logo.png",
    information: "Мраморна олтарна маса ( V – VI в.)",
    light_intensity: 1,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.65, -0.25, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 12 * Math.PI / 18,
        title: "Артефакт",
        description: "Мраморната олтарна маса е с датировка V – VI в. Открита е в базилика №1.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.65, -0.25, 0.045),
        value: "2",
        alpha: 5 * Math.PI / 18,
        beta: 12 * Math.PI / 18,
        title: "Технология",
        description: "Олтарните маси се изработват от мрамор, имат правоъгълна или полукръгла форма и по периферията са украсени с архитектурни елементи: прагове, фризове, полукръгли вдлъбнатини.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.65, 0.15, 0.045),
        value: "3",
        alpha: -12 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Необходимост",
        description: "Олтарната маса е най-важната и задължителна част от литургичното обзавеждане. При богослужения върху олтарната маса се поставят Евангелието, мощите на светеца, който се почита в конкретния храм, разпятието и дарохранителницата.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.65, 0.15, 0.045),
        value: "4",
        alpha: -6 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Предназначение",
        description: "Олтарната маса – на латински (menza sacra) фокусира богослужебния живот и има едно основно предназначение – върху нея се поставят дарове и се принася безкръвната жертва (хляб и вино), която по мистичен начин се превръща в тяло и кръв Христови.",
        infoAlignment: 'left'
      }
    ]
  },
  "black_krater" : {
    name: "Чернофигурна ваза – кантарос или кратер (V в. пр. Хр.)",
    file: "BlackFigured_Krater.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "arete-logo.png",
    information: "Чернофигурна ваза – кантарос или кратер (V в. пр. Хр.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.55, -0.1, 0.24),
        value: "1",
        alpha: 3 * Math.PI / 4,
        beta: 7 * Math.PI / 18,
        title: "Артефакт",
        description: "Глинен чернофигурен кратер, цял. Много добре запазен. Автор: Неизвестен, Размер: 40см. Датировка: V в.пр. Хр. Материал: Керамика",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, 0.16, 0.14),
        value: "2",
        alpha: 3 * Math.PI / 6,
        beta: 6 * Math.PI / 18,
        title: "Технология",
        description: "Съдът е с широко отворено устие, къса фуниевидна шийка и сфероидно тяло. Дъното е върху средновисока профилирана подставка. Дръжките започват от устието и достигат до най-широката част на съда. Кратерът е изработен от фина, бсжовокафява глина и покрит с оранжев на цвят фирнис. Върху него е рисувано с черен фирнис. Подробностите по фигурите от композицията “полегнали мъже” са подчертани чрез издраскване с остър фин резец. Това придава обем на изобразените сцени.<br/><br/>Чернофигурният кратер е бил изработен в някое от наи-големите гръцки ателиета. Подобен кратер не е известен от българските земи.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.648, 0.392, 0.035),
        value: "3",
        alpha: 3 * Math.PI / 2,
        beta: 3 * Math.PI / 18,
        title: "Кратер",
        description: "Кратер (от древногръцкото κρατήρ, от глагола κεράννυμι, „смесвам“) е характерен за Древна Гърция керамичен съд, предназначен за смесване на вино и вода. Кратерите са доста големи съдове с широко тяло и голямо устие. Могат да имат хоризонтални дръжки, поставени близо до основата, или вертикални, издигащи се от рамото. След като са напълнени стават трудно преносими и затова са поставяни върху триножник в средата на помещението, а разреденото с вода вино се е черпело от тях с други съдове. Изработвани са от метал или керамика и често са боядисани или изящно орнаментирани.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.4, 0.1, -0.3),
        value: "4",
        alpha: -Math.PI / 2,
        beta: Math.PI / 2,
        title: "Първа фигурална група",
        description: "Украсата е фигурална. От едната страна на фигуралното поле са представени две полегнали фигури на мъже с дълги заострени бради. Телата са покрити с богато декорирани наметки само до кръста. </p> <p>Единият от мъжете държи голям дълъг ритон, нарисуван с бяла боя. Тялото му е предадено “анфас”, а главата в профил. Другият мъж е полегнал гърбом към първия и държи в дясната си ръка дълго клонче. Фигурите са изваяни много прецизно. Телата са предадени с всички анатомични подробности. Срещу втората фигура в скок е показан делфин. Коремната част на делфина и перката са изрисувани с бяла боя. </p>",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.35, -0.04, 0.3),
        value: "5",
        alpha: Math.PI / 2,
        beta: Math.PI / 2,
        title: "Втора фигурална група",
        description: "На втората фигурална сцена (№2) са представени също двама полегнали мъже. </p><p>Единият е възрастен и с протегната напред ръка, в която също държи ритон. Срещу него е седнал друг по-млад мъж с ритон в лявата ръка. Зад фигурата му се подава дълго клонче с цветове (или пъпки). И тези мъже са с бради. Богато украсени наметки покриват долните половини на телата им. Композицията се повтаря и зад втория мъж и тук се вижда фигура на делфин в скок.</p>",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.4, 0.28, -0.35),
        value: "6",
        alpha: Math.PI,
        beta: Math.PI / 2,
        title: "Допълнителна украса",
        description: "<p>Горният край на фигуралното поле завършва с фин орнамент от къси пръчици, като ресни. Долният край пък е подчертан с две линии - червена и черна. Под тях следва поле с повтарящ се растителен орнамент, нарисуван с черен фирнис върху оранжев фон.</p><p> Шийката, дръжките и столчето са покрити изцяло с черен фирнис. Ръбът на устието е сложно профилиран и украсен с растителен орнамент. </p>",
        infoAlignment: 'right'
      }
    ]
  },
  "black_skifos" : {
    name: "Чернофигурен скифос (V в. пр. Хр.)",
    file: "BlackFigured_Skifos.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "arete-logo.png",
    information: "Чернофигурен скифос (V в. пр. Хр.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, 0, 0),
    scale: 3.7,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.35, 0.05, 0.28),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 6 * Math.PI / 18,
        title: "Артефакт",
        description: "Глинен чернофигурен скифос, цял. Много добре запазен.<br/>Автор: Неизвестен,<br/>Размер: 10 см.<br/>Датировка: V в. пр. Хр.<br/>Материал: Керамика",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, 0.06, 0.2),
        value: "2",
        alpha: 6 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Технология",
        description: "Вътрешната страна, устието и долната част на тялото със столчето са покрити с черен, лъскав фирнис. Устието е с леко извит навън ръб, тялото е дълбоко. пресечено конусовидно и стъпва върху ниско, дисковидно столче.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.4, 0.1, -0.26),
        value: "3",
        alpha: -6 * Math.PI / 18,
        beta: 5 * Math.PI / 18,
        title: "Скифос",
        description: "Скифос (на старогръцки σκύφος) е древногръцка керамична купа за пиене на ниско столче с две хоризонтални дръжки. Скифосът е митичният бокал на Херкулес, поради което скифосът се нарича още бокалът на Херкулес. Изображенията на скифос често се срещат върху древногръцки вази, направени в стила на черно-червенофигурната вазова живопис.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.35, 0.07, -0.42),
        value: "4",
        alpha: -8 * Math.PI / 18,
        beta: 7 * Math.PI / 18,
        title: "Разпространение",
        description: "Подобни скифоси са разпространени в Ритзона (Беотия) и Атика. Ексеплярите, открити на територията на България са главно от некрополи – Аполония Понтика и могилния некропол при Дуванли. Формата се датира към 480-450 г. пр. Хр. и наподобява т. нар. „Група на Пистиас “, но с по-късна датировка.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.57, 0.225, 0.015),
        value: "5",
        alpha: -9 * Math.PI / 18,
        beta: 0,
        title: "Дръжки",
        description: "Хоризонталните дръжки са разположени върху най-издутата част на тялото и достигат малко над устието. На нивото на дръжките н под тях има пояс в червено, който служи като фон на чернофигурните изображення.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.35, -0.1, 0.35),
        value: "6",
        alpha: 7 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Лъвове",
        description: "Върху двете страни са представени двойка лъвове, един срещу друг. Животните са изобразени приклекнали върху предните си лапи, готови за нападение. Фигурата на лъва в ляво е дефектна – главата липсва, личи разливане на фирниса при шията. Предните крака са изпълнени като небрежно очертан триъгълник.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.5, -0.1, -0.23),
        value: "7",
        alpha: Math.PI,
        beta: 10 * Math.PI / 18,
        title: "Палмети",
        description: "Животинските изображения са фланкирани от двете страни с по една палмета с дълъг, извит лист. Фигурите са дадени сумарно, изпълнението е небрежно.",
        infoAlignment: 'right'
      }
    ]
  },
  "bronze_dagger" : {
    name: "Бронзов нож или кама (XVI-XII в. Пр.Хр.)",
    file: "Bronze_Dagger.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "arete-logo.png",
    information: "Бронзов нож или кама (XVI-XII в. Пр.Хр.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, -Math.PI / 2, 0),
    scale: 1.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.4, 0.4, 0.1),
        value: "1",
        alpha: 12 * Math.PI / 18,
        beta: Math.PI / 4,
        title: "Артефакт",
        description: "Бронзов нож или кама, цял. Много добре запазен. Автор: Неизвестен,<br/>Размер: 30 см.<br/>Датировка: II в. пр. Хр.<br/>Материал: Бронз",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.4, 0.2, 0.1),
        value: "2",
        alpha: 6 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Технология",
        description: "Острието и дръжката са лети компактно.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.4, -0.1, 0.1),
        value: "3",
        alpha: 0,
        beta: Math.PI / 2,
        title: "Кинжал",
        description: "Камата, наричана още кинжал, е вид нож с две остри страни, използвана за промушване и защита. Острието на камата е сравнително късо и не надминава 50 сантиметра. За първи път се появява още при примитивните сечива и е изработвана от кремък или кост. Металната кама се появява през бронзовата епоха. През средновековието и ренесанса е използвана в комбинация със сабя при дуели.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.4, -0.5, 0.1),
        value: "4",
        alpha: -6 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Разпространение",
        description: "Точен аналог на кинжала досега не е известен, но подобни по форма са характерни за Пруто-Днестровския район. Кинжал с подобна украса е познат от с. Черковна, Варненско.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.4, -0.9, 0.1),
        value: "5",
        alpha: -12 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Острие",
        description: "Острието е с листовидна форма, украсено с три релефни надлъжни ребра в една линия с набодени точки, а в основата на острието с врязани линии са оформени три триъгълника.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.4, 0.8, 0.1),
        value: "6",
        alpha: -10 * Math.PI / 18,
        beta: Math.PI / 4,
        title: "Дръжка",
        description: "Дръжката (ръкохватката) е с конична форма, елипсовидно напречно сечение и има кръгъл полусферичен край.",
        infoAlignment: 'right'
      }
    ]
  },
  "bronze_pomegranate" : {
    name: "Бронзов съд във формата на Нар (III в. пр. Хр.)",
    file: "Bronze_Pomegranate.glb",
    information: "Бронзов съд във формата на Нар (III в. пр. Хр.)",
    light_intensity: 7,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(-2 * Math.PI/18, 16 * Math.PI / 18, 0),
    scale: 4,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.5, 0.15, -0.05),
        value: "1",
        alpha: Math.PI / 2,
        beta: Math.PI / 2,
        title: "Артефакт",
        description: "Бронзов съд във формата на Нар, цял. запазен. Автор: Неизвестен,<br/>Размер: 7 см.<br/>Датировка: III в. пр. Хр.<br/>Материал: Бронз",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.33, 0.33, -0.05),
        value: "2",
        alpha: 4 * Math.PI / 6,
        beta: Math.PI / 4,
        title: "Технология",
        description: "Съд от нар със сфероидно тяло. На повърхността има различни по форма и големина вдлъбнатини, с помощта на които е осъществено реалистичното изобразяване на зрелия плод. На върха на сферата е запоено късо конусовидно стъбло. Има елипсовиден отвор и вдлъбнатина, където са били поставени златните бижута.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.4, 0.3, -0.18),
        value: "3",
        alpha: Math.PI / 4,
        beta: Math.PI / 2,
        title: "Нар",
        description: "Нарът е символ на блаженството в Отвъдното. Древната митология го свързва с Персефона, която не успяла да устои на изкушението да вкуси плода и по този начин заслужила да прекара част от времето си в Хадес. От другата страна, вкусвайки от нара, младата богиня надвила лишенията, които са божествен закон в царството на Смъртта. Жрицата на Деметра обикновено увенчавала главите им с венци от клонки от нар в Елевзина, но плодът, който убил Персефона, бил забранен за непосветените. В описанието на кабирските мистерии Климент Александрийски отбелязва забраната да се ядат падналите на земята зърна от нар, тъй като те се смятат за капките от кръвта на Дионис.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.5, -0.15, -0.114),
        value: "4",
        alpha: Math.PI / 4,
        beta: Math.PI / 2,
        title: "Златни семена",
        description: "Червените искрящи семена на този адски плод са част от хтоничния огън, който издигайки се на земната повърхност ще роди новия живот. Този митологичен контекст дава основание за по-нататъшна интерпретация на колективната находка.<br/>В конкретната археологическа ситуация съблазнителните семена са заменени от златните бижута, тъй като в семантиката на металите златото означава кръвта и огъня.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0, -0.28, 0.085),
        value: "5",
        alpha: 1.5 * Math.PI / 4,
        beta: 1.5 * Math.PI / 4,
        title: "Пръстен",
        description: "Пръстен е вид бижу, което се носи на пръста на ръката или крака. И мъжете, и жените носят пръстени, макар да е много по-често явление при жените. Те могат да са направени от метал, дърво, пластмаса, стъкло, кост или друг материал. Най-често използваните метали са злато – жълто или бяло и сребро.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.39, -0.1, 0.23),
        value: "6",
        alpha: 9 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Пръстен с камък",
        description: "Могат да са украсени с полускъпоценен или скъпоценен камък, като сапфир, диамант или рубин. Годежните пръстени и сватбените халки се носят на безименния пръст. В България преди церемонията на брака годежния пръстен се носи на дясната ръка, а по време на самата сватба се премества на лявата ръка. В САЩ се носи на лявата ръка. Някои от пръстените са гравирани, а други може да имат и други функции, например пръстен-часовник. Пръстените могат да имат и символично значение.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.45, -0.24, 0.2),
        value: "7",
        alpha: Math.PI,
        beta: -Math.PI / 6,
        title: "Обици",
        description: "Обиците са популярно украшение още от дълбока древност. В Азия преди 7000 години са правени мъжки обици. За древните египтяни и асирийци обицата е символ на високо положение в обществото. В древна Гърция и Рим обиците са били носени като знак на храброст. Изработените от сребро или злато обици, украсени със скъпоценни камъни са се носели с гордост от римлянките и гъркините, с което са показвали принадлежност към висока социална класа.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.13, -0.15, 0.085),
        value: "8",
        alpha: 2.5 * Math.PI / 4,
        beta: Math.PI / 2,
        title: "Кулие",
        description: "Вид бижу, често се прави от различни видове метали и гарнира с цветни камъни – скъпоценни или полускъпоценни, дърво (обикновено гравирано и полирано), стъкло, пера, черупки, мъниста или корали.",
        infoAlignment: 'right'
      }
    ]
  },
  "herakl" : {
    name: "Статуя на Херакъл (I – III в. пр. Хр.)",
    file: "Statuya_Herakles.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "arete-logo.png",
    information: "Статуя на Херакъл (I – III в. пр. Хр.)",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(-Math.PI/10, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.35, -0.3, 0.1),
        value: "1",
        alpha: 12 * Math.PI / 18,
        beta: Math.PI / 2,
        title: "Артефакт",
        description: "Представен е митичния герой Херакъл, прав, гол, с преметната през рамо лъвска кожа.<br/>Автор: Неизвестен,<br/>Размер: 20 см.<br/>Датировка: I – III в. пр. Хр.<br/>Материал: бронз",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.2, 0.48, 0.03),
        value: "2",
        alpha: Math.PI / 2,
        beta: 8 * Math.PI / 18,
        title: "Лицето",
        description: "Фигурата е на мъж в зряла възраст с брада и мустаци. Лицето е издължено. Очите са предадени с две бадемовидни кухини. Носът е дълъг, с леко разширени ноздри. Брадата е гъста и пада на кичури. Мустаците са увиснали и достигат до долния край на брадата. Косата е прибрана, отпред леко повдигната нагоре, а отзад - превързана с тясна панделка.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.35, 0, 0.1),
        value: "3",
        alpha: 6 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Тялото",
        description: "Липсват долните части на ръцете. Лявата ръка е отчупена в долния край, а дясната е запазена до лакътя. Фалосът е релефно представен. Тялото и особено краката са с изразена мускулатура. В областта на гърдите статуетката е леко смачкана.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.35, 0, 0.1),
        value: "4",
        alpha: 4 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Херакъл",
        description: "Син е на Зевс и Алкмена. Брат близнак е на Ификъл. Той е първият съпруг на Мегара, вторият съпруг на Омфала, съпруг на Деянира, от която е баща на Хил и Макария (дъщеря на Херакъл), след някои други на Авга и след смъртта си на богинята Хеба, освен това любовник на Иола и на Абдер. Баща е на много деца.<br/>Отгледан е от Амфитрион, съпругът на майка му.<br/>По майчина линия той принадлежи към рода Персеиди.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.35, 0.3, 0.1),
        value: "5",
        alpha: -7 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Култ",
        description: "Култът към Херакъл е бил много почитан в днешните български земи през римската епоха. Митичната сила на героя го е правила много популярен сред младежите и войниците. На много места Херакъл е бил почитан в синкретична връзка с Дионис.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.35, 0.3, 0.1),
        value: "6",
        alpha: 10 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Кожата на немейския лъв",
        description: "Лъвската кожа е преметната през лявото рамо. Немейският лъв в древногръцката митология е ужасяващо чудовище, което опустошавало околностите на град Немея, откъдето дошло и името му. Дете е на Тифон и Ехидна. Бил удивително едър и имал твърда като стомана кожа, неуязвима за оръжия.",
        infoAlignment: 'right'
      }
    ]
  },
  "nagradna_ikona" : {
    name: "Евлогия с изображение на Св Димитър",
    file: "Sveti_Dimitar_Nagradna_Ikona.glb",
    hall: "Зала \"Христовите войни\"",
    logo: "arete-logo.png",
    information: "Евлогия с изображение на Св Димитър",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.3, -0.15, 0.38),
        value: "1",
        alpha: 8 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Нагръдна икона на Свети Димитър на кон и надпис на гръцки език в рамка от фолклорни мотиви.<br/>Автор: Неизвестен,<br/>Размер: 5,5/5,5 см.<br/>Датировка:19 в.<br/>Материал:Сребро",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.3, -0.15, 0.38),
        value: "2",
        alpha: 9 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Иконна евлогия",
        description: "Иконата е от типа реликварии и съдържа автентични мощи. Гръцката дума – ευλογία (благословия) има обобщаващо значение за широк кръг паметници на поклоническото изкуство. В този термин се включват реликвиарии. Съхранява реликви,  което определя тяхното лесно разпространение и използване като форма на благословия и лична защита.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.3, 0, 0.38),
        value: "3",
        alpha: 7 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Сред творбите на византийската дребна пластика се откроява малка група паметници, чието предназначение не е достатъчно изяснено, а названието им се отбелязва по различен начин. Това са нагръдни икони и медальони, чиито корпуси са оформени като миниатюрни кутии.<br/>Технология на изработка: отлята в двусъставен калъп. Изображенията са отлети в плитък релеф. Използвани са вероятно двусъставни керамични калъпи.<br/>Изработен е по византийски модели и образци в гръцко ателие, навярно свързано с църковен и манастирски комплекс.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.3, 0, 0.38),
        value: "4",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Светецът",
        description: "В иконографията Свети Димитър се изобразява като светец воин. В ранните иконографски типове обикновено е представен в допоясно изображение, или в иконите от царския ред на иконостаса – седящ на трон. В тези случаи обикновено пронизва с копие или меч скорпион. След XVI век, заедно с други светци воини, е представен като един от конниците на апокалипсиса – той язди червен кон. В тези изображения Свети Димитър убива някакъв символ на злото.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.3, 0.15, 0.38),
        value: "5",
        alpha: -5 * Math.PI / 18,
        beta: 7 * Math.PI / 18,
        title: "Култ",
        description: "С мощите на св. Димитър е свързан византийският град Солун, където възниква и се развива култът към светеца и където е издигната прочутата базилика, на която е патрон. През средните векове продължил да съществува големият мартириум на св. Димитър в Солун, а наред с него е продължило и разпространението на поклоннически предмети с образа на прочутият мъченик.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.3, 0.15, 0.38),
        value: "6",
        alpha: 5 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Любопитно",
        description: "Разглежданите оловни енколпиони евлогии са най-ранните паметници с този сюжет, свързан със св. Димитър. Логично е да считаме, че тази иконография възниква в Солун по време на управлението на кръстоносците и е много вероятно да е пряко повлияна от изобразителни паметници, донесени от остров Кипър, който е тяхно владение. Свързан с култа към светеца, епизодът не случайно е илюстриран на част от поклонническата продукция.<br/>Хронологическият диапазон на този род поклоннически знаци, изглежда обхваща периода на латинското управление на града 1204- 1224.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.2, 0.1, 0.38),
        value: "7",
        alpha: 7 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Конник",
        description: "Димитър е представен като триумфатор на кон в ход надясно. С дясната ръка държи изправено нагоре копие, а с лявата понякога е вдигнал кръгъл щит. Светецът е облечен в мрежеста ризница, изпълнена с кръстосан щрих, къса туника и хламида. Зад него, върху коня седи юноша.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.23, -0.1, 0.38),
        value: "8",
        alpha: 11 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Кон",
        description: "След XVI век, заедно с други светци воини, е представен като един от конниците на апокалипсиса – той язди червен кон.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.23, 0.1, 0.38),
        value: "9",
        alpha: 5 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Тропар",
        description: "Велик поборник в бедите вселената те намери, страдалче, побеждаващ народите, защото, посрамил гордостта на Лий, вдъхновил си за дръвновен подвиг Нестор. Тъй, свети Димитре, Христа Бога моли да дарува нам велика радост.",
        infoAlignment: 'left'
      }
    ]
  },
  "sveti_georgi_malka" : {
    name: "Икона на Свети Георги (XIX в.)",
    file: "Sveti_Georgi_Malka.glb",
    hall: "Зала \"Христовите войни\"",
    logo: "arete-logo.png",
    information: "Свети Георги",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.8, -0.4, 0),
        value: "1",
        alpha: 7 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Артефакт",
        description: "Икона на Свети Георги.<br/>Автор: Николай Павлович,<br/>Размер: 40/ 29 см.<br/>Датировка: 1870г.<br/>Държащ колело на мъчението в лявата си ръка.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.8, -0.4, 0),
        value: "2",
        alpha: 22 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Технология",
        description: "Основата и се състои от дървен панел - от иглолистна дървесина. Грунда на произведението е с дебелина 2 мм, многослоен, лепилен. Живописта е изпълнена в техниката „яйчна темпера“. Телесните части са рисувани многослойно, за разлика от дрехите които не съдържат повече от 3 слоя. Използвани са листово злато и декоративни лакови бои.Иконата е покрита с дамаров лак.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.8, 0, 0),
        value: "3",
        alpha: 9 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Автор",
        description: "<p>Николай Павлович е роден на 9 декември 1835 г. в Свищов. Син е на видния възрожденски деец Христаки Павлович, който остава в историята ни като един от големите просветни дейци на българското Възраждане, и брат на лекаря Димитър Павлович. Николай остава сирак, той познава силата и значението на историческата памет, която е главна в творчеството му. Умира в София на 13 февруари 1894 година. Между 1852 и 1858 г. той учи последователно в две големи европейски художествени академии – Виенската и Мюнхенската. След средата на ХІХ в. се развива и историческата живопис, чийто пионер е Николай Павлович. Той рисува и икони, като се старае да съчетава традициите на бащиния си занаят с принципите на академичната живопис, в които е обучен.</p",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.8, 0, 0),
        value: "4",
        alpha: 14 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Светецът",
        description: "Според сказанието Св.Георги произхожда от знатна кападокийска фамилия, роден след 280 г. Твърди се, че бил 20 годишен военачалник и е убит преди абдикацията на Диоклециян в 305г. Баща му Геронтий е висш държавен администратор – езичник, а майка му Полихрония – християнка. След смъртта на на баща си Георги се премества в Палестина, където постъпва в римската войска и достига висок чин. Участва в мащабните императорски експедиции в Персия, Британия, Ливан и други области. Празникът на св. Георги днес се отбелязва на 6 май, когато, съгласно църковния календар, се фиксира започването на лятната половина на годината.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.8, 0.4, 0),
        value: "5",
        alpha: 4 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Култ",
        description: "Св. Георги е покровител на земеделците (в превод от гръцки името му означава „земеделец”) и скотовъдите. По времето на Средновековието култът определено го превръща в безстрашен войн, предводител на армията и патрон на много владетели. И днес, в България Гергьовден се празнува по най-тържествен начин. В народната песен се пее „... хубав ден – Велик ден, още по-хубав – Гергьовден.” Тавматургичните разкази в житието на светеца, изцеряването на болни, които го посещават в килията му, възкресението на вол и мъртвец, унищожаването на езическите идоли в храма на Аполон са чудесата извършени приживе от светеца, като той продължил да чудотворства и след смъртта си.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.6, -0.2, 0),
        value: "6",
        alpha: 10 * Math.PI / 18,
        beta: 12 * Math.PI / 18,
        title: "Колело",
        description: "Заради твърдата му вяра бил подложен на различни мъчения, от тежки по-тежки: слагали огромен камък върху гърдите му; връзвали го гол на дървено колело с набити пирони; държали го три дни в яма с негасена вар; обували му железни нагорещени обуща и го карали да тича с тях; давали му да пие силни отрови. Благодарение на силната си вяра в Христос, Георги понесъл стоически всички мъчения. Сам Господ Бог му се явил и само с допира на ръката Си излекувал раните му. На новите мъчения, измисляни от страна на императора, Георги смело отговарял:\"По-скоро ти ще се умориш да ме мъчиш, отколкото аз – да понасям мъченията.\"",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, 0.2, 0),
        value: "7",
        alpha: 6 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Кръст",
        description: "Кръстът е един от най-древните символи на човечеството, използван в много религии, но най-вече в християнството. Вертикалната линия символизира божественото, а хоризонталната – земното. Кръстът е пряко свързан с мъченическата смърт на Иисус Христос. Разпъването на кръст е било разпространено средство на наказание в древния Рим. Макар тогава кръстът да е бил символ на смъртта, в християнството той се превръща в символ на живота. Благодатта и силата на Честния кръст не са в неговата форма, тоест във външния му вид, неговата сила и могъщество са в това, че той е Христов кръст, той е оръдието, с което Христос е спасил света.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0.2, 0),
        value: "8",
        alpha: Math.PI / 2,
        beta: Math.PI / 2,
        title: "Военни атрибути",
        description: "Оръжията на светците говорят както за общественния статут, така и за времето, в което са живяли те. Военни атрибути са непроменени или може да се счита, че те са основна част от иконографията им. По тях може да се определи и разпознае дори в каква длъжност, ранг е бил издигнат той и да се датира спрямо облеклото, приблизително по кое време са се ползвали военните му атрибути.",
        infoAlignment: 'right'
      }
    ]
  },
  "sveti_georgi_goliama" : {
    name: "Икона на Свети Георги (XIX в.)",
    file: "Sveti_Georgi_Goliama.glb",
    hall: "Зала \"Христовите войни\"",
    logo: "arete-logo.png",
    information: "Свети Георги",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, 19 * Math.PI / 18, 0),
    scale: 2.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.8, -0.6, 0),
        value: "1",
        alpha: 7 * Math.PI / 18,
        beta: 7 * Math.PI / 18,
        title: "Артефакт",
        description: "Икона на Свети Георги<br/>Автор: Неизвестен,<br/>Размер 160/ 79см.<br/>Датировка: 1889г.<br/>Държащ копие и щит.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.8, -0.6, 0),
        value: "2",
        alpha: 4 * Math.PI / 18,
        beta: 15 * Math.PI / 18,
        title: "Технология",
        description: "Темпера, дървен панел, сребърен обков. Иконографията на лицето на св. Георги се появява във Византия и края на Х и през ХІ в. То е младо и красиво,с правилна овална форма. Особено характерни са гъстите и къдрави коси, които го обграждат. В такъв вид е представен светецът на миниатюрите в Псалтира на Василий ІІ (1019) г., в паметници от ХІІ в., в които достига своята класическа завършеност, във фреска от църквата Асин в Кипър (1106-1132) г., в иконата на св. Георги, св. Димитър и св. Тодор Тирон в Ермитажа от втората половина на ХІІ в., както и във фреските от храма в Кинцвиси в Грузия, датирани в края на ХІІ в.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.8, -0, 0),
        value: "3",
        alpha: 30 * Math.PI / 18,
        beta: 7 * Math.PI / 18,
        title: "Светецът",
        description: "Едни от най-древните изображения на св. Георги произхождат от южномалоазийската провинция Кападокия, в която той, според агиографските данни, е роден. Знае се, че от средите на кападокийската аристокрация се излъчват едни от най-талантливите командири във византийската войска, което изглежда е спомогнало за възприемането на светците воини като покровители на империята и на войската. В България военните светци са на почит във всички храмове, независимо от техните патрони. Това явление може би се дължи донякъде на честите войни през Средновековието, но се корени и в обстоятелството, че българските владетели заимстват от времето на Симеон. <br/>Велики насам твърде много религиозни, духовни и битови реалии от византийските василевси. Сред тях са култовете на светците воини, чиито покровителствени функции са идеологически иззети във вреда на Византия, за да се внуши самочувствие и храброст на българската войска.на ХІІ в.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.8, 0, 0),
        value: "4",
        alpha: 5 * Math.PI / 18,
        beta: 12 * Math.PI / 18,
        title: "Любопитно",
        description: "Силното сходство на иконографията на св. Меркурий с тази на св. Георги е станало причина през вековете инициалите на св. Меркурий да са заменяни с тези на св. Георги, което е довело до не дотам голям брой стенописни изображения на светеца-конник. Култът на \"варварските\" (гърците и римляните наричали другоплеменниците варвари) светци-воини е бил контаминиран с култовете на св. Георги и св. Димитър, като не случайно св. Димитър и св. Георги устойчиво започват да се изобразяват заедно. Иконографията на св. Меркурий, убиващ император Юлиян или \"елински\" мъдреци, по-късно се трансформира в иконографията на св. Димитър, убиващ цар Калоян или неверници. Имаме и разказ, как св. Георги убива император Диоклециан и св. Димитър убива Гавраил Радомир. В случая е важно да се каже, че \"цареубийството\", показно извършвано от светцитевоини, е крайно рядък жест. Разказите за подобни случки никога не излизат от кръга на ромейските и българските владетели. По същата логика, разказите за магическата употреба на константинополските артефакти са свързани почти изключително само с българския и ромейския народ.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.8, 0.6, 0),
        value: "5",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Воин",
        description: "Светците като правостоящи римски воини възпроизвеждат изобразяването на боговете на войната Арес и Марс и особено на Марс, който най-често държи меч или копие в дясната ръка и е положил лявата си ръка върху опрения на земята щит. В такава приемственост не може да се търси друго обяснение, освен функционалния континуитет между езически богове и светците-воини.<br/>В България военните светци са на почит във всички храмове, независимо от техните патрони. Това явление може би се дължи донякъде на честите войни през Средновековието, но се корени и в обстоятелството, че българските владетели заимстват от времето на Симеон Велики насам твърде много религиозни, духовни и битови реалии от византийските василевси. Сред тях са култовете на светците воини, чиито покровителствени функции са идеологически иззети във вреда на Византия, за да се внуши самочувствие и храброст на българската войска.на ХІІ в.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.8, 0.6, 0),
        value: "6",
        alpha: 5 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Копие",
        description: "Военните светци най- често са представени с копия и мечове и много рядко с лък и стрели в колчан. Тези изображения са съвсем реалистични и ответните им аналози в музеите, дават основание да се предполага, че такива оръжия са действително използвани,а всичко това подсказва колко значимо е наследството, оставено от зографите майстори през Средновековието.",
        infoAlignment: 'left'
      }
    ]
  },
  "sveti_dimitar_malka" : {
    name: "Икона Свети Димитър (1870г.)",
    file: "Sveti_Dimitar_Malka.glb",
    hall: "Зала \"Христовите войни\"",
    logo: "arete-logo.png",
    information: "Свети Димитър",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.6, -0.3, 0.045),
        value: "1",
        alpha: 7 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Артефакт",
        description: "Икона на Свети Димитър.<br/>Автор: Николай Павлович,<br/>Размер: 40/ 29 см.<br/>Датировка: 1870г.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, -0.3, 0.045),
        value: "2",
        alpha: 5 * Math.PI / 18,
        beta: 14 * Math.PI / 18,
        title: "Светецът",
        description: "В иконографията Свети Димитър се изобразява като светец воин. В ранните иконографски типове обикновено е представен в допоясно изображение, или в иконите от царския ред на иконостаса – седящ на трон. В тези случаи обикновено пронизва с копие или меч скорпион. След XVI век, заедно с други светци воини, е представен като един от конниците на апокалипсиса – той язди червен кон.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0, 0.045),
        value: "3",
        alpha: 6 * Math.PI / 18,
        beta: 6 * Math.PI / 18,
        title: "Светецът",
        description: "<p> Следите от дионисиевия тип религиозност ясно личат в имената на мъчениците. „Димитър” означава „Деметрин”, чедо на великата богиня –майка в хипостазата и на Майка-Земя (Деметра) както в единичната си функция, така и в двоичната - с брат - близнак. Рожбите на Великата богиня-майка, които я разорават, т. е. оплождат в свещенобрачното си самопожертвование, са нейни Синове, чийто хипостази се превъплащават в светци-воини. </p> <p> От значение за осъзнаването на превъплащенията на военно-земеделски и военно-мистериални божества в светци-воини са календарните рамки, в които те са поставени и действат. Празникът на св. Георги – 23 април (стар стил) и на св. Димитър - 26 октомври (стар стил) посочват началото и края на лятното полугодие от индо-европейската година, която се дели на два, а не на четри сезона. </p>",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, 0.3, 0.045),
        value: "4",
        alpha: 24 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Солун",
        description: "Градът Солун е основан през 305 г. пр. Хр., от Касандър, син на диадоха Антипатър, цар на Македония (317-298 г. пр. Хр.). Той синойкизира (обединява) селищата Солунския залив, чиито най-вероятен център е Терме, съгласно Страбон. Касандър нарекъл новото селище на името на съпругата си, дъщеря на Филип II и сестра на Александър Велики. Името Тесалоники (Салоники), българизирано в Солун, съдържа името Тесалос - син на Херакъл в „Илияда” на Омир, и Нике – богинята на победата. От края на XII до началото на XIV в. Солун става важен политически и духовен център на Византийската империя заради тежките дни на кръстоносните походи и османското нашествие. По това време защитникът на града, за какъвто е приет св. Димитър, се превръща в централна фигура на упованието за спасение.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.6, 0.3, 0.045),
        value: "5",
        alpha: 6 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Любопитно",
        description: "През юни 1978 г. в Атинската академия е съобщено откритието на византоложката Мария Теохари, която идентифицира светите мощи на св. Димитър в италианския манастир Сан Лоренцо ин Кампо в Северна Италия. През октомври същата година мощите са пренесени в Солун, за да останат там „вовеки”, и да даряват жителите на града с благословенното миро. Образът на св. Димитър е описан в многото жития, които, както посочих, за първи път започват да се пишат през VI в. и продължадат да се пишат на гръцки език поне още три столетия.<br/>Смята се, че през IX в. Анастасий Библиотекар превежда на латински език едно житие на светеца, което вероятно произхожда от VI в. Така, сподед проф. Д. Иванов, се полагат основите на една достатъчно богата агиографска книжнина. Според нея Димитър живял приблизително около три века след Исус Христос - бил роден най-вероятно в 280 г. Опоменато от Симеон Метафраст, семейството му принадлежало към най-древните фамилии в римската провинция Македония. Неговите родители, чиито имена не са отбелязани, са били видни първенци в Солун, баща му бил градоначалник и вероятно таен християнин.",
        infoAlignment: 'right'
      }
    ]
  },
  "sveti_dimitar_goliama" : {
    name: "Икона на Свети Димитър (1889г.)",
    file: "Sveti_Dimitar_Goliama.glb",
    hall: "Зала \"Христовите войни\"",
    logo: "arete-logo.png",
    information: "Свети Димитър",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 2.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.6, -0.4, 0),
        value: "1",
        alpha: 12 * Math.PI / 18,
        beta: 11 * Math.PI / 18,
        title: "Артефакт",
        description: "Икона на Свети Димитър.<br/>Автор: Неизвестен,<br/>Размер: 160/ 79 см.<br/>Датировка: 1889г.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, -0.4, 0),
        value: "2",
        alpha: 8 * Math.PI / 18,
        beta: 13 * Math.PI / 18,
        title: "Светецът",
        description: "<p>Според житията, Димитър, когото вече били започнали да наричат „свети”, изрекъл думите „В името на Христа, който ни каза да премазваме всякакви змии и скорпиони и да рушим всяка мощ на врага”. Тогава той бил посетен от ангел, който му вдъхнал вяра, сила и го увенчал с златния венец на победата. Това бил и мигът в който св. Димитър тръгнал по пътя на „подражанието на Христа”. </p>",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0.4, 0),
        value: "3",
        alpha: 12 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Чудо",
        description: "<p> Според легендата, последователи на св. Димитър открили измъченото му тяло още през нощта и веднага и на същото място го погребали. През 313 г., веднага след като Константин I Велики оповестил едикта си, че християнството става равноправна религия в Импрерията редом с другите вероизповедания, над гроба на св. Димитър била издигната малка църква. </p> <p> Много били хората получили изцеление именно в този малък храм. През 412-413 г. епархът Леонтий бил изцелен точно там и в знак на благодарност провинциалният управител вдигнал по-голям храм на мястото на предишния. Заедно с това, според едно не до там сигурно сведение, отнесъл със себе си и част от мощите и плаща. Според източници, по времето на новия градеж мощите били положени в сребърен ковчег. </p>",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, 0.4, 0),
        value: "4",
        alpha: 24 * Math.PI / 18,
        beta: 7 * Math.PI / 18,
        title: "Фолклор",
        description: "<p><strong>„ХРИСТОВИЯ ВОИН”</strong> </p> <p> Според изследванията на проф. Димитър Иванов, празникът на „Христовия воин” св. Димитър фактически възпроизвежда „Марсовия завършек” на двусезонната година на „мъжките дела” в мир и в бран.<br/>Св. Димитър е дълбоко вкоренен образ и във фолклорното християнство. Димитровден/Митровден, се празнува на 26 октомври, който е и денят на светия великомъченик Димитър Чудотворец. Тази дата в църковния календар е сред така наречените неподвижни празници и с нея се поставя началото на цял цикъл „Неподвижни ознаменувания” - Рождество Богородично, Кръстовден и т. н. до 15 август. Фолклорната традиция го определя като брат на св. Архангел Михаил, „Душовадника Рангел”, онзи, който „взима душите” на мъртвите и е почитан на следващия по дата неподвижен празник, Архангеловден (8 ноември).</p>",
        infoAlignment: 'right'
      }
    ]
  },
  "tantzuvashti_nimfi_goli": {
    name: "Оброчна плоча на Танцуващи нимфи (II – III в.)",
    hall: "Зала \"Антично наследство\"",
    logo: "am-logo.png",
    file: "Tantzuvashti_Nimfi_Goli.glb",
    information: "Оброчна плоча на Танцуващи нимфи (II – III в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.55, -0.45, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Представени са трите нимфи - грации. Плочата е открита при разкопки на римските терми на Диоклецианополис.<br/>Датира се от II – III в. пр. Хр.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, -0.45, 0.045),
        value: "2",
        alpha: 6 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е от мрамор. Има добре запазен посветителски надпис на гръцки език.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.55, 0, 0.045),
        value: "3",
        alpha: 9 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Фигурална група",
        description: "Нимфите са представени като три голи млади жени (грации). Средната нимфа е с гръб и е прегърнала страничните две.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, 0, 0.045),
        value: "4",
        alpha: 12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Надпис",
        description: "На горното надписно поле е направено посвещение. В него нимфите са споменати като покровителки на дърветата (дриади). На долната рамка е изписано името на посветителя и означението на плочката като благодарствен дар. Целият текст на оброчната плоча в превод гласи: „На нимфите, покровителки на дърветата, Север, син на Амоний, посвети благодарствен дар“",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.55, 0.3, 0.045),
        value: "5",
        alpha: -6 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Нимфеум",
        description: "Нимфеумите са познати от най-дълбока древност. Обикновено се намират в тихи, гористи местности, край скали, пещери или вода. Свързват се с мистични практики и лечебни процедури. Откритите култови предмети и оброчни плочи на нимфите посочват наличието на нимфеум около хисарските минерални извори.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.55, 0.3, 0.045),
        value: "6",
        alpha: 6 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Култ",
        description: "Култът към трите нимфи бил широко разпространен в Тракия. След приемането на християнството за равноправна религия се слага край на съществуването на езическите божества. Вярата в нимфите обаче не е била прекъсната. В представите на хората, пазителките на минералните извори са се съхранили като самодиви, диви и русалки.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0, 0.62, 0.045),
        value: "7",
        alpha: 9 * Math.PI / 18,
        beta: 6 * Math.PI / 18,
        title: "Безсмъртие",
        description: "Въпреки божествената си същност нимфите са уязвими и не са безсмъртни. Умират когато изсъхне дървото или пресъхне изворът, който обитават. Лечебните извори в Хисаря продължават да даряват здраве на хората. Това означава, че нимфите не са изчезнали и все още пазят изворите.",
        infoAlignment: 'left'
      },
    ]
  },
  "obrochna_plocha_dionis": {
    name: "Оброчна плоча на Дионис (II – III в.)",
    hall: "Зала \"Антично наследство\"",
    logo: "am-logo.png",
    file: "Obrochna_Plocha_Dionis.glb",
    information: "Оброчна плоча на Дионис (II – III в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.6, -0.45, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Датира се от II – III в. пр. Хр. Представя младия бог Диόнис, съпроводен от сатири и менади.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, -0.45, 0.045),
        value: "2",
        alpha: 6 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е от мрамор с изваяни фигури върху плочата.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0, 0.045),
        value: "3",
        alpha: 9 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Фигурална група",
        description: "Плочата изобразява увеселение, на което всички участници свирят на различни инструменти. В центъра е Дионис, който държи в ръка змия – питон, а с другата си ръка е прегърнал сатир. От дясно Пан свири на сиринга - духов инструмент познат с популярното име панфлейта, до него две менади свирят на тимпан и дайре.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.6, 0, 0.045),
        value: "4",
        alpha: 12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Митични създания",
        description: "<p> Сатирите, изобразявани с кози копита и рога, са били постоянни спътници и на Дионис - богът на виното, и прекарвали времето си в пиене, танцуване и преследване на нимфи. В изкуството са били изобразявани с кози рога, а младите с костни възли на челата си, с копита и конска опашка. </p> <p> Менадите са били изобразявани като жени, които тичат след Дионис с развети коси, полуголи, държат в ръка тирс и проглушават гори и планини с викове.&nbsp; </p> <p> Змията е почитана от много народи още от най-древни времена. Според вярванията на много народи змията е посредник между света на живите и света на мъртвите. </p>",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0.3, 0.045),
        value: "5",
        alpha: -6 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Музикални инструменти",
        description: "<p> Сиринга е духов инструмент познат с популярното име панфлейта, наименуван на Пан, древногръцкия бог на природата и овчарите, често изобразяван с такъв инструмент. В древногръцката митология, Сиринга (Σύριγξ) е горска нимфа, превърнала се във водна тръстика, опитвайки се да избяга от привързаността на бог Пан. Той изрязва няколко парчета от тръстиката, поставя ги успоредно едно до друго и ги завърза, създавайки мелодичнния музикален инструмент. Панфлейтата е духов инструмент. Звукът се произвежда от вибрацията на въздушен поток, навлизащ през отвор в края на резониращата тръба. Дължината на тръбата определя основната честота. </p> <p> Тимпаните и дайрето са музикални перкусионни инструменти. Тимпаните се състоят от полусферична част, наречена кубé, кожа, обръч и настройващ механизъм, а за направа на дайрето се използват обръч, кожа и зилове. </p>",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.6, 0.3, 0.045),
        value: "6",
        alpha: 6 * Math.PI / 18,
        beta: 8 * Math.PI / 18,
        title: "Ритуали",
        description: "Тържествата, в чест на бог Дионис по тракийските земи са били едни от най-атрактивните представления. Траели няколко дни. Шествия от млади мъже и жени, облечени в кожи като сатирите, обикаляли храмовете и изпълнявали заклинания. След това започвало веселието с много танци и вино. Без съмнение, увеселения, посветени на този бог са били организирани и в римския град Диоклецианополис, където освен минерална вода се е пиело и хубаво червено вино, което по лекарски предписания е било включено в лечебната терапия.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0, 0.62, 0.045),
        value: "7",
        alpha: 9 * Math.PI / 18,
        beta: 6 * Math.PI / 18,
        title: "Дионисиеви мистерии",
        description: "Дионис обикновено се определя като бог на виното и веселието, но той има и по-висша, духовна същност – умира и се ражда, както се възражда природата в естествения цикъл на живота. По своята безсмъртна същност той се доближава до орфизма. Свещените орфически ритуали се извършвали през пролетта и изобразявали мъките, смъртта и възкресението на Дионис. Елементи от дионисиевите мистерии се срещат и сега в някои от традиционните празници и ритуали – кукери и нестинари. Други са трансформирани в християнски, като Трифон Зарезан и така са се съхранили през вековете.",
        infoAlignment: 'left'
      },
    ]
  },
  "lion_head": {
    name: "Мраморна лъвска глава за чешма (II в.)",
    file: "Mramorna_Lavska_Glava.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "am-logo.png",
    information: "Мраморна лъвска глава за чешма (II в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.55, -0.4, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Мраморна лъвска глава за чешма от II в. Намерена е в аподитериума - съблекалнята на Римските терми.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, -0.4, 0.045),
        value: "2",
        alpha: 12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е много прецизно от древните майстори. Материалът, който е използван за изработката на плочата е мрамор.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.55, 0, 0.045),
        value: "3",
        alpha: 9 * Math.PI / 18,
        beta: 11 * Math.PI / 18,
        title: "Визия",
        description: "На лицевата страна на главата са представени в подробности характерните особености на лъва. Устата е оформена във вид на отвор с почти правоъгълно сечение, през който е преминавала водата. Добре са очертани мустаците на лъва и две двойки зъби.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.55, 0, 0.045),
        value: "4",
        alpha: -6 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Предназначение",
        description: "На обратната страна на лъвската глава отворът е изсечен във форма на конус за монтиране на изхода на водопровода, който е отвеждал минералната вода към басейна в един от калдариумите на термите.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.55, 0.45, 0.045),
        value: "5",
        alpha: Math.PI / 2,
        beta: 9 * Math.PI / 18,
        title: "Символика",
        description: "Глава с изображение на лъв често се поставяла на чешми и особено там, където имало минерални извори, защото според поверието лечебната сила на минералната вода символизирала лъвската сила!",
        infoAlignment: 'right'
      },
    ]
  },
  "bronzova_panther": {
    name: "Бронзова статуетка на пантера (II – III в.)",
    file: "Bronzova_Panther.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "am-logo.png",
    information: "Бронзова статуетка на пантера (II – III в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.6, -0.4, 0.045),
        value: "1",
        alpha: -12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Артефакт",
        description: "Бронзова статуетка на пантера, датирана<br/> от II – III в.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.7, 0, 0.045),
        value: "2",
        alpha: 12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е от бронз. Липсват част от краката. Пантерата е в ход наляво, с извита в същата посока глава. Разтворена уста и прибрани назад уши. Лявата предна лапа е вдигната. Козината на животното е представена чрез гравирани кръгчета и насечки с посребряване. Има голяма кухина разположена в дясната част на тялото.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.6, 0.25, 0.045),
        value: "3",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Луксозна украса",
        description: "Тези фигури са характерни за украсата на луксозните пътнически коли в Римската империя в периода от средата на І в. до ІV в. Те стъпват на дъговидна основа. Статуетката има два шипа от долната страна за приковаване към дърво. Винаги по две са украсявали лисиците зад задната ос на колата. Такива украси са откривани по територията на цялата римска империя като единични находки. Но когато са в комплекси с коли, те винаги са откривани при четириколки на меко окачване.",
        infoAlignment: 'right'
      },
    ]
  },
  "solaren_kultov_predmet": {
    name: "Соларен култов предмет (V в. пр. Хр.)",
    file: "Solaren_Kultov_Predmet.glb",
    hall: "Зала \"Антично наследство\"",
    logo: "am-logo.png",
    information: "Соларен култов предмет (V в. пр. Хр.)",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.7, -0.4, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Соларен култов предмет, датиран е от V в. пр. Хр. Предметът произхожда от тракийското селище при с. Кръстевич.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.7, 0, 0.045),
        value: "2",
        alpha: -12 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Технология",
        description: "Култов предмет с кръгла форма, изработен от камък (базалт). На лицевата страна е изобразена спирала, чието начало е от центъра към периферията. По цялата повърхност са изсечени симетрични прави линии, във форма на слънчеви лъчи.<br/>Обратната страна е гладка, почти полирана. На едно място на периферията е издълбана малка дупка за закачване на стена.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.7, 0.4, 0.045),
        value: "3",
        alpha: 6 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Символика",
        description: "Спиралата е най-древния символ и се свързва с цикъла: живот-смърт-прераждане. В древността тя е символизирала Слънцето, защото се е вярвало, че то се ражда всяка сутрин и умира вечерта, за да се прероди отново на сутринта. От него Природата черпи енергия, флората разцъфтява и се преражда за нов живот. Слънцето е началото, но и края на житейския цикъл. Слънцето е светлина, а светлината символизира още живота и доброто, знанието, божествеността и духовността.",
        infoAlignment: 'right'
      },
    ]
  },
  "silver_hand": {
    name: "Сребърна ръка от икона (V в.)",
    file: "Silver_Hand.glb",
    hall: "Зала \"Ранно Християнство\"",
    logo: "am-logo.png",
    information: "Сребърна ръка от икона (V в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.35, -0.25, 0.045),
        value: "1",
        alpha: 11 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Намерена е при археологически разкопки в Хисаря. Датира се от V в.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.35, -0.25, 0.045),
        value: "2",
        alpha: 5 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е от сребро. Вгражда се в икона или е куха, за да съхранява светите мощи.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.35, 0.2, 0.045),
        value: "3",
        alpha: -12 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Символ",
        description: "Сребърната ръка е много силен християнски символ. Това е „ръката, която дава”!",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.35, 0.2, 0.045),
        value: "4",
        alpha: 14 * Math.PI / 18,
        beta: 10 * Math.PI / 18,
        title: "Вяра",
        description: "Познати са много икони със сребърни ръце, обикновено на Богородица, които извършват чудеса. На църковни празници се изнасят пред храмовете, за да могат миряните да се поклонят и целунат ръката за опрощение и здраве.",
        infoAlignment: 'right'
      }
    ]
  },
  "silver_reliquary": {
    name: "Сребърна мощехранителница (V в.)",
    file: "Silver_Reliquary.glb",
    hall: "Зала \"Ранно Християнство\"",
    logo: "am-logo.png",
    information: "Сребърна мощехранителница (V в.)",
    light_intensity: 3,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(-Math.PI/4, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.5, 0.35, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 3 * Math.PI / 18,
        title: "Артефакт",
        description: "Намерена е при археологически разкопки на раннохристиянската базилика № 3, посветена на Св. Стефан и датирана от VI век.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.62, -0.2, 0.045),
        value: "2",
        alpha: 5 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Технология",
        description: "Изработена е от сребро и представлява кутия с елипсовидна форма, покрита с капак, който в средата е изпъкнал, а в краищата завършва с профил за захлупване.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.65, 0, -0.2),
        value: "3",
        alpha: -12 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Допълнителна украса",
        description: "От външната страна на сребърната мощехранителница са врязани гръцки букви.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.65, 0.2, 0.045),
        value: "4",
        alpha: 5 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Употреба",
        description: "В нея са съхранявани нетленните останки (мощи) от светец. Още от времето на император Константин Велики и неговата майка Елена, която започнала да събира вещи, свързани с Христос (като части от Разпятието, трънения венец, плащеницата, копието, с което е прободен, кости и дрехи от други апостоли), се породило желанието на всеки храм да има частица от светите хора като знак за изцеление. Поставяли се в красиви, специално изработени кутийки от сребро, злато, олово или ценна дървесина с обков. Ако мощите са от светеца, дал име на църквата, тогава те имат по-голяма сила и извършват чудеса. Така към всеки храм се отправят богомолци, за да се поклонят на мощите.",
        infoAlignment: 'left'
      }
    ]
  },
  "silver_spoon": {
    name: "Сребърна лъжица за причастие (V – VI в.)",
    file: "Silver_spoon.glb",
    hall: "Зала \"Ранно Християнство\"",
    logo: "am-logo.png",
    information: "Сребърна лъжица за причастие (V – VI в.)",
    light_intensity: 5,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3.5,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.25, -0.3, 0.045),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 12 * Math.PI / 18,
        title: "Артефакт",
        description: "Намерена е при археологически разкопки в Хисаря.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.25, -0.3, 0.045),
        value: "2",
        alpha: 8 * Math.PI / 18,
        beta: 15 * Math.PI / 18,
        title: "Свещенодействие",
        description: "Свещеникът поставя с лъжичка в устата на причастяващия се Светото Причастие - частици хляб и вино, които са Тялото и Кръвта Христови.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(0.25, 0.2, 0.045),
        value: "3",
        alpha: -12 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Употреба",
        description: "Тя е била използвана и за причестяване в християнските молитвени домове. Употребата на лъжичката за пречистяване не е постановявано от църковен събор. Нейната употреба е въвеждана постепенно.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(-0.25, 0.2, 0.045),
        value: "4",
        alpha: 2 * Math.PI / 18,
        beta: 6 * Math.PI / 18,
        title: "История",
        description: "Първото ясно доказателство за използването на лъжички за пречистяване датира от края на XI в. До средата на XII в. причастието се извършвало с обща лъжица, която след причастието на всеки един мирянин е била обеззаразявана с оцет – общоизвестен дезинфектант още от древни времена.",
        infoAlignment: 'right'
      }
    ]
  },
  "iron_cross": {
    name: "Бронзов кръст (V – VI в.)",
    file: "Iron_Cross_with_chain.glb",
    hall: "Зала \"Ранно Християнство\"",
    logo: "am-logo.png",
    information: "Бронзов кръст (V – VI в.)",
    light_intensity: 30,
    lightmaps: [],
    lightmaps_intensity: 0,
    position: new Vector3(0, 0, 0),
    rotation: new Vector3(0, Math.PI, 0),
    scale: 3,
    hotpointSize: 0.15,
    hotpoints: [
      {
        position: new Vector3(-0.2, -0.07, 0.4),
        value: "1",
        alpha: 9 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Артефакт",
        description: "Този кръст е открит при археологически разкопки в гр. Хисаря. Може да го видите в експозицията на музея.",
        infoAlignment: 'right'
      },
      {
        position: new Vector3(0.7, 0.1, 0.4),
        value: "2",
        alpha: 3 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Символ",
        description: "Кръстът е най-мощният християнски символ. Носенето му показва съпричастността на духовници и миряни към мъките на Спасителя на Голгота. Разпъването на кръст било традиционно наказание в Римската империя. Но след като император Константин Велики видул кръста насън в нощта преди битка (312 г.) и чул думите „In hoc signo vinces“ („С този знак ще победиш“), той станал църковен символ.",
        infoAlignment: 'left'
      },
      {
        position: new Vector3(-0.2, 0.3, 0.4),
        value: "3",
        alpha: -12 * Math.PI / 18,
        beta: 9 * Math.PI / 18,
        title: "Развитие",
        description: "Победата на бойното поле направила Константин единствен император. След това той издал Едикт, разрешаващ изповядването на християнската вяра в империята. От тук насетне вярващите повече не били преследвани.",
        infoAlignment: 'left'
      }
    ]
  },
}
